import React, { useRef, useEffect } from 'react'

import { CSSObject } from '@emotion/react'
import styled from '@emotion/styled'
import {
  Box,
  Text,
  Link,
  Color,
  Heading4,
  AlignItems,
  JustifyContent,
  FontFamily,
  Display,
  TextAlign,
  useTheme,
  BoxProps,
  FlexDirection,
} from '@gousto-internal/citrus-react'

import SeedsDesktopVariantImg from '../assets/seeds-desktop-variant.png'
import SeedsMobileImg from '../assets/seeds-mobile.png'

const trustPilotSliderWidgetId = '54ad5defc6454f065c28af8b'

const LeftSeedsArea = (props: BoxProps) => {
  const { theme } = useTheme()

  const Component = styled(Box)(() => ({
    backgroundPosition: 'bottom left',
    transform: 'rotate(180deg)',
    ...(theme.responsiveStyle(
      [`url(${SeedsMobileImg})`, `url(${SeedsDesktopVariantImg})`],
      ['backgroundImage'],
    ) as CSSObject),
  }))

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />
}

const RightSeedsArea = (props: BoxProps) => {
  const { theme } = useTheme()

  const Component = styled(Box)(() => ({
    backgroundPosition: 'bottom left',
    ...(theme.responsiveStyle(
      [`url(${SeedsMobileImg})`, `url(${SeedsDesktopVariantImg})`],
      ['backgroundImage'],
    ) as CSSObject),
  }))

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} />
}

const TrustPilotVariant = () => {
  const ref = useRef(null)
  useEffect(() => {
    // widget may not load if the bootstrapper script has been loaded before the component gets rendered
    // we use the TrustPilot loadFromElement function to manually load the widget if this happens

    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true)
    }
  }, [])

  return (
    <Box
      display={Display.Flex}
      flexDirection={[FlexDirection.Column, FlexDirection.Row]}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.SpaceBetween}
      maxHeight={['auto', '380px']}
      minHeight={['240px', '144px']}
      bg={Color.NeutralGrey_50}
      data-testid="TrustPilot"
    >
      <LeftSeedsArea
        height={['64px', '100%']}
        width={['100%', '124px']}
        minHeight={[null, '324px']}
      />
      <Box paddingV={10} paddingBottom={5} flexGrow={1} width={['100%', 'auto']} maxWidth="1171px">
        <Heading4 fontFamily={FontFamily.SemiBold} textAlign={TextAlign.Center}>
          Over
          <Text display={Display.Inline} color={Color.Primary_600} fontFamily={FontFamily.Bold}>
            {' '}
            1 million meals{' '}
          </Text>
          cooked and loved
        </Heading4>
        <div
          ref={ref}
          className="trustpilot-widget"
          data-locale="en-GB"
          data-template-id={trustPilotSliderWidgetId}
          data-businessunit-id="512cda6e000064000522fb6a"
          data-style-height="240px"
          data-style-width="100%"
          data-theme="light"
          data-stars="4,5"
          data-review-languages="en"
          data-font-family="Montserrat"
          data-text-color={Color.ColdGrey_800}
          data-testid="TrustPilotContainerVariant"
        >
          <Link href="https://uk.trustpilot.com/review/gousto.co.uk" target="_blank">
            Trustpilot
          </Link>
        </div>
      </Box>
      <RightSeedsArea
        height={['64px', '100%']}
        width={['100%', '124px']}
        minHeight={[null, '324px']}
      />
    </Box>
  )
}
export { TrustPilotVariant }
